import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {NotFoundErrorComponent} from './not-found-error/not-found-error';

const routes: Routes = [
  {
    path: '404',
    component: NotFoundErrorComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ErrorPageRoutingModule {
}
